<h4 class="title">User Status Marking</h4>
<div class="card-box">
    <div class="row" style="padding: 0px 0px 23px 10px;">
        <div class="col-md-6">
            <h5 class="form-lable">User:</h5>
            <p-dropdown [options]="types" [(ngModel)]="cli_type" placeholder="Select" optionLabel="y"
                [showClear]="true"></p-dropdown>
        </div>
        <div class="col-md-6">
            <h5 class="form-lable">Status:</h5>
            <p-dropdown [options]="types" [(ngModel)]="cli_type" placeholder="Select" optionLabel="y"
                [showClear]="true"></p-dropdown>
        </div>
        <div class="col-md-3">
            <h5 class="form-lable">Start date:</h5>
            <p-calendar [showIcon]="true" inputId="icon"></p-calendar>
        </div>
        <div class="col-md-3">
            <h5 class="form-lable">End date:</h5>
            <p-calendar [showIcon]="true" inputId="icon"></p-calendar>
        </div>
        <div class="col-md-6">
            <h5 class="form-lable">Remarks:</h5>
            <textarea rows="3" cols="30" pInputTextarea [(ngModel)]="address"></textarea>
        </div>
        <div class="col-md-4">
            <h5 class="form-lable">Attachment:</h5>
            <input type="file">

        </div>
        <div class="col-md-6 mt-20">
            <button type="button" class="btn btn-primary">Update</button>
            <!-- <button type="button" class="btn btn-primary btn-bg-blue" (click)="cancel()">Cancel</button> -->
        </div>
        <div class="col-md-12 mt-20">
            <div class="card-box">
                <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
                    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [globalFilterFields]="['type']">
    
                    <ng-template pTemplate="header">
                        <tr class="thhead">
                            <th class="th-1">
                                S.No
                            </th>
                            <th>
                                User Type
                            </th>
                            <th>
                                User Name
                            </th>
                            <th>
                                User Address
                            </th>
                            <th>Role</th>
                            <th>Email</th>
                            <!-- <th>Created by</th>
                        <th>Modified by</th>
                        <th>Created at</th>
                        <th>Modified at</th> -->
                            <th style="width: 110px;text-align:center">
                                Action
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr class="tdrow">
                            <td>{{i+1}}</td>
                            <td>
                                {{item.i}}
                            </td>
                            <td>{{item.i}}</td>
                            <td>{{item.i}}</td>
                            <td>{{item.i}}</td>
                            <td>
                                {{item.i}}
                            </td>
                          <td class="act">
                                <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" (click)="Delete(item._id)"
                                    pTooltip="Delete"></i>
                                <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true"
                                    (click)="client_form_view(item)" pTooltip="Profile"></i>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>